export default "__VITE_ASSET__9577f75c__"